import {
  getPage,
  getDetail,
  getClientPage,
  datevehicleInfoGrouptypelimit,
  datetypelimit,
} from '@/api/vehicleofflineanalysisregulationserv'

export default {
  state: {
    state_VehicleOfflineAnalysisRegulation_GetPageResult: null,
    state_VehicleOfflineAnalysisRegulation_GetDetailResult: null,
    state_VehicleOfflineAnalysisRegulation_GetClientPageResult: null,
    state_VehicleOfflineAnalysisRegulation_DatevehicleInfoGrouptypelimitResult: null,
    state_VehicleOfflineAnalysisRegulation_DatetypelimitResult: null,
  },
  mutations: {
    SET_VEHICLEOFFLINEANALYSISREGULATION_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisRegulation_GetPageResult = rst;
    },
    SET_VEHICLEOFFLINEANALYSISREGULATION_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisRegulation_GetDetailResult = rst;
    },
    SET_VEHICLEOFFLINEANALYSISREGULATION_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisRegulation_GetClientPageResult = rst;
    },
    SET_VEHICLEOFFLINEANALYSISREGULATION_DATEVEHICLEINFOGROUPTYPELIMIT_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisRegulation_DatevehicleInfoGrouptypelimitResult = rst;
    },
    SET_VEHICLEOFFLINEANALYSISREGULATION_DATETYPELIMIT_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisRegulation_DatetypelimitResult = rst;
    },
  },
  actions: {
    VehicleOfflineAnalysisRegulationServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleOfflineAnalysisRegulationServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleOfflineAnalysisRegulationServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleOfflineAnalysisRegulationServ_DatevehicleInfoGrouptypelimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datevehicleInfoGrouptypelimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_DATEVEHICLEINFOGROUPTYPELIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_DATEVEHICLEINFOGROUPTYPELIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleOfflineAnalysisRegulationServ_Datetypelimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datetypelimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_DATETYPELIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISREGULATION_DATETYPELIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehicleOfflineAnalysisRegulation_GetPageResult: state => {
      return state.state_VehicleOfflineAnalysisRegulation_GetPageResult;
    },
    get_VehicleOfflineAnalysisRegulation_GetDetailResult: state => {
      return state.state_VehicleOfflineAnalysisRegulation_GetDetailResult;
    },
    get_VehicleOfflineAnalysisRegulation_GetClientPageResult: state => {
      return state.state_VehicleOfflineAnalysisRegulation_GetClientPageResult;
    },
    get_VehicleOfflineAnalysisRegulation_DatevehicleInfoGrouptypelimitResult: state => {
      return state.state_VehicleOfflineAnalysisRegulation_DatevehicleInfoGrouptypelimitResult;
    },
    get_VehicleOfflineAnalysisRegulation_DatetypelimitResult: state => {
      return state.state_VehicleOfflineAnalysisRegulation_DatetypelimitResult;
    },
  }
}